import { useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { UserBookInfo } from '../common/UserBookInfo';
import { scrollToElement } from '../../../lib/userFunctions';
import { UserBookEpisodeList } from '../episode/UserBookEpisodeList';

export const UserBookView = ()=>{
    const { school, book } = useParams();
    const navigate = useNavigate();

    useEffect(() => scrollToElement('userbook_subpage'), []);
    if(book===-1) navigate(`/${school}/userbook`);

    
    return (
        <div className="userBookView">
            <UserBookInfo useDelete={true} bookId={book} isEpisodeListPage={true} />
            <UserBookEpisodeList book={book} />
        </div>
    );
};